import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import {
    NavLink, useLocation
} from "react-router-dom";

const { SubMenu } = Menu;

interface MenuItemWithSeparatorProps {
    isVisibleSeparator?: boolean;
    children: any
}



interface NavigationMenuProps {
    isNavMenuVisible: boolean;
    isToggleMenuVisible: boolean;
    onCloseNavigationMenu?: any;
}

export const NavigationMenu = (props: NavigationMenuProps) => {
    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const location = useLocation()

    const handleMenuItemClick = (obj: any) => {
        setOpenKeys((prevOpenKeys) => (prevOpenKeys.includes(obj.key) ? [] : [obj.key]));
    };

    useEffect(() => {
        const currentPath = location.pathname;
        const keys = currentPath.split('/').filter(Boolean);
        setOpenKeys(keys);
    }, [location.pathname]);

    const MenuItemWithSeparator = (props: MenuItemWithSeparatorProps) => (
        <>
            <Menu.Item>
                {props.children}
            </Menu.Item>

            {
                props.isVisibleSeparator ?
                    <></>
                    : <Menu.Item className="menu-separator">|</Menu.Item>
            }
        </>
    );

    return (
        <div>
            {
                props.isToggleMenuVisible &&
                <Menu
                    mode="inline"
                    className="nav-menu"
                    openKeys={openKeys}
                >
                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/" exact activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Anasayfa
                        </NavLink>
                    </Menu.Item>

                    <SubMenu key="hakkimizda" title="Hakkımızda" className="submenu-content"
                        onTitleClick={handleMenuItemClick}
                    >
                        <Menu.Item key="baskan-hakkinda" onClick={handleMenuItemClick}>
                            <NavLink to="/hakkimizda/baskan-hakkinda" onClick={props.onCloseNavigationMenu} activeClassName="active-link">Ali Yakub Baba Hakkında</NavLink>
                        </Menu.Item>
                        <Menu.Item key="size-olan-mesajimiz" onClick={handleMenuItemClick}>
                            <NavLink to="/hakkimizda/size-olan-mesajimiz" onClick={props.onCloseNavigationMenu} activeClassName="active-link">Size Olan Mesajımız</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <SubMenu key="mursidlerim" title="Mürşidlerim" className="submenu-content"
                        onTitleClick={handleMenuItemClick}
                    >
                        <Menu.Item key="muzaffer-aski-ozak" onClick={handleMenuItemClick}>
                            <NavLink to="/mursidlerim/muzaffer-aski-ozak" onClick={props.onCloseNavigationMenu} activeClassName="active-link">Muzaffer Aşkî Ozak</NavLink>
                        </Menu.Item>
                        <Menu.Item key="sefer-dal" onClick={handleMenuItemClick}>
                            <NavLink to="/mursidlerim/sefer-dal" onClick={props.onCloseNavigationMenu} activeClassName="active-link">Sefer Dal</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/sema" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Sema
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/books" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Kitaplar
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/hacc-hatiralari" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Hacc
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/itikaf-hatiralari" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            İtikaf
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/mukabele" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Mukabele
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/galeri" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Galeri
                        </NavLink>
                    </Menu.Item>

                    <Menu.Item onClick={handleMenuItemClick}>
                        <NavLink to="/allahin-hidayet-gunesi" activeClassName="active-link" onClick={props.onCloseNavigationMenu}>
                            Hidayet Güneşi
                        </NavLink>
                    </Menu.Item>
                </Menu>
            }

            {
                props.isNavMenuVisible &&
                <Menu
                    mode="horizontal"
                    className="nav-menu"
                >
                    <MenuItemWithSeparator>
                        <NavLink to="/" exact activeClassName="active-link">
                            Anasayfa
                        </NavLink>
                    </MenuItemWithSeparator>

                    <SubMenu key="hakkimizda" title="Hakkımızda" className="submenu-content">
                        <Menu.Item key="baskan-hakkinda">
                            <NavLink to="/hakkimizda/baskan-hakkinda" activeClassName="active-link">Ali Yakub Baba Hakkında</NavLink>
                        </Menu.Item>
                        <Menu.Item key="size-olan-mesajimiz">
                            <NavLink to="/hakkimizda/size-olan-mesajimiz" activeClassName="active-link">Size Olan Mesajımız</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item className="menu-separator">|</Menu.Item>

                    <SubMenu key="mursidlerim" title="Mürşidlerim" className="submenu-content">
                        <Menu.Item key="muzaffer-aski-ozak">
                            <NavLink to="/mursidlerim/muzaffer-aski-ozak" activeClassName="active-link">Muzaffer Aşkî Ozak</NavLink>
                        </Menu.Item>
                        <Menu.Item key="sefer-dal">
                            <NavLink to="/mursidlerim/sefer-dal" activeClassName="active-link">Sefer Dal</NavLink>
                        </Menu.Item>
                    </SubMenu>

                    <Menu.Item className="menu-separator">|</Menu.Item>

                    <MenuItemWithSeparator>
                        <NavLink to="/sema" activeClassName="active-link">
                            Sema
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/books" activeClassName="active-link">
                            Kitaplar
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/hacc-hatiralari" activeClassName="active-link">
                            Hacc
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/itikaf-hatiralari" activeClassName="active-link">
                            İtikaf
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/mukabele" activeClassName="active-link">
                            Mukabele
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator>
                        <NavLink to="/allahin-hidayet-gunesi" activeClassName="active-link">
                            Hidayet Güneşi
                        </NavLink>
                    </MenuItemWithSeparator>

                    <MenuItemWithSeparator isVisibleSeparator={true}>
                        <NavLink to="/galeri" activeClassName="active-link">
                            Galeri
                        </NavLink>
                    </MenuItemWithSeparator>
                </Menu>
            }
        </div>
    )
}
